import { useQueryClient } from '@tanstack/react-query';
import { Button, Form, Input, Modal, Select } from 'antd';

import { path } from 'app/hooks/data/adminBookingDetails/useAdminBooking';
import type { CancelBookingForm } from 'app/hooks/data/bookings/useCancelBooking';
import { useCancelBooking } from 'app/hooks/data/bookings/useCancelBooking';
import { useCancellationReasons } from 'app/hooks/data/useCancellationReasons';

import './CancelModal.scss';

const { Option } = Select;

type Props = {
  isModalOpen: boolean;
  setIsModalOpen: (bool: boolean) => void;
  code: string;
};

export const CancelModal = ({ isModalOpen, setIsModalOpen, code }: Props) => {
  const [form] = Form.useForm();
  const { data: cancellationReasons } = useCancellationReasons();
  const { mutateAsync: cancelBooking } = useCancelBooking();
  const queryClient = useQueryClient();

  const handleOk = async (values: CancelBookingForm) => {
    await cancelBooking({ code, body: values });

    queryClient.invalidateQueries({ queryKey: [path, { bookingCode: code }] });
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Cancel booking"
      open={isModalOpen}
      width={572}
      closable
      destroyOnClose
      onCancel={() => setIsModalOpen(false)}
      centered
      className="booking-cancel-modal"
      footer={[
        <Button onClick={form.submit} type="primary">
          Confirm
        </Button>,
      ]}
    >
      <Form onFinish={handleOk} form={form} layout="vertical">
        <div className="form-row">
          <div className="title">Reason type</div>
          <Form.Item
            label="Reason type"
            name="reasonId"
            rules={[{ required: true }]}
            noStyle
          >
            <Select>
              {cancellationReasons?.map((reason) => (
                <Option key={reason.id} value={reason.id}>
                  {reason.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="form-row">
          <div className="title">Comment</div>
          <Form.Item label="Comment" name="comment" noStyle>
            <Input.TextArea rows={2} placeholder="Optional" />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
